export function AdminDefault (pConfig)
{
  return (
  {
    name : 'EditorToolbarDefaultConfig',

    GroupsChange :
    {
      BlockStylesMini :
      {
        visible: false
      },

      BlockStylesEmail :
      {
        visible: false
      },

      FontColorsEmail :
      {
        visible: false
      },

      HistoryActionsMini:
      {
        visible : false
      },

      TextAlignMini:
      {
        visible : false
      },

      FontColorsMini:
      {
        visible : false
      },

      TextActionsMini:
      {
        visible : false
      },

      CopyPasteMini:
      {
        visible : false
      },

      HTMLMini :
      {
        visible: false
      },

      BigSizeButtonsMini :
      {
        visible: false
      },

      BigSizeButtonsEvent :
      {
        visible: false
      },

      BigSizeButtonsEmail :
      {
        visible: false
      }
    }
  });
}